'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BottomRegionContentStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var base = function base(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
  return '\n    font-family: ' + fontFamily + ';\n  ';
};

var BottomRegionContentStyled = exports.BottomRegionContentStyled = _styledComponents2.default.div.withConfig({
  displayName: 'BottomRegionContentStyled'
})(['width:100%;display:flex;box-sizing:border-box;', ';'], base);

BottomRegionContentStyled.displayName = 'BottomRegionContentStyled';